export const showPage = (page, values) => {
  if (page.ConditionQuestionID === "0" || !page.ConditionQuestionID) {
    return true;
  }

  let value = "";
  const condition = page.ConditionValue || "";

  try {
    value =
      values.questions?.find(
        (somePage) => somePage?.[`q${page.ConditionQuestionID}`]
      )?.[`q${page.ConditionQuestionID}`] || "";

    if (Array.isArray(value)) {
      value = value.map((point) => JSON.parse(point));
    }

    if (!Array.isArray(value) && value) {
      value = [JSON.parse(value)];
    }
  } catch (e) {}

  if (Array.isArray(value)) {
    const match = value.find(
      ({ Value }) =>
        (page.ConditionFilter === "eq" && Value === condition) ||
        (page.ConditionFilter === "ne" && Value !== condition)
    );

    return !!match;
  }

  return (
    (page.ConditionFilter === "eq" && value === condition) ||
    (page.ConditionFilter === "ne" && value !== condition)
  );
};

export default showPage;
